import { gql } from "@apollo/client";

const UPDATE_OPT_IN = gql`
  mutation updateInstitutionOptInStatus($opt_in: Boolean!) {
    updateInstitutionOptInStatus(opt_in: $opt_in){
    opt_in }
  }
`;

export default UPDATE_OPT_IN;
